import { useLanguage } from './index';
import { translations } from './translations/index';

// Translation function type
export type TranslationFunction = (key: string, fallback?: string) => string;

// Custom hook for translations
export function useTranslation(): {
  t: TranslationFunction;
  language: 'en' | 'zh';
} {
  const { language } = useLanguage();

  // Translation function
  const t: TranslationFunction = (key: string, fallback?: string) => {
    try {
      // Split the key by dots to navigate nested objects
      const keys = key.split('.');
      let value: any = translations[language];

      // Navigate through the nested object
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          // Key not found, return fallback or key itself
          console.warn(`Translation key "${key}" not found for language "${language}"`);
          return fallback || key;
        }
      }

      // Return the translation if it's a string
      if (typeof value === 'string') {
        return value;
      } else {
        console.warn(`Translation key "${key}" does not resolve to a string for language "${language}"`);
        return fallback || key;
      }
    } catch (error) {
      console.error(`Error retrieving translation for key "${key}":`, error);
      return fallback || key;
    }
  };

  return { t, language };
}
